import { getUrl } from '../fetch';
import { trackedServiceCall } from '../uniqueIDTransferHelper';

import { IMatchingEngineWaterfall } from './IMatchingEngineWaterfallResponse';

export async function getWaterfallById(
    id: string
): Promise<IMatchingEngineWaterfall | null> {
    try {
        // Instrumented because this function swallows its own errors into null,
        // which made a waterfall failure indistinguishable from a partner with
        // no waterfall configured. The null return is preserved.
        const response = await trackedServiceCall('matchingEngineWaterfall', () =>
            getUrl<{ data: IMatchingEngineWaterfall }>(
                `/api/data/waterfall/${id}`
            )
        );
        return response.data;
    } catch (error) {
        return null;
    }
}
